import { Component, Inject, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatPaginator, MatTableDataSource } from '@angular/material';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CalendarEventsService } from 'app/main/shared/services/calendarEvent.service';
import { CaseService } from 'app/main/shared/services/case.service';
import { LocalUserService } from 'app/main/shared/services/localUser';
import { PreSignService } from 'app/main/shared/services/preSign.service';
import { getMonthName } from '../../../shared/utils/dateUtils';
import * as _ from 'lodash';
import { CaseActionComponent } from '../../common/case-action/case-action.component';

@Component({
  selector: 'app-docket-case',
  templateUrl: './docket-case.component.html',
  styleUrls: ['./docket-case.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DocketCaseComponent implements OnInit {

  displayedColumns: string[] = ['case_number', 'ward', 'created_date','modified_date', 'type', 'move'];
  loading: boolean = false;
  orgId: any;

  @ViewChild(MatPaginator) set matPaginator(paginator: MatPaginator) {
    this.tableData.paginator = paginator;
  }

  tableData = new MatTableDataSource<any>();

  hearings = [];

  caseIds = [];

  casesList = [];

  showTable = false;

  downloadLink: any;

  casesToBeMoved: any = [];

  removeBtn: boolean = true;

  constructor(public dialogRef: MatDialogRef<DocketCaseComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private calendarEventsService: CalendarEventsService,
    private localUser: LocalUserService, private caseService: CaseService, private router: Router,
    private presignService: PreSignService, public dialog: MatDialog) {
      this.orgId = this.localUser.getOrganizationId();
    }

  ngOnInit() {
    if(this.data) {
      this.getDocketCases();
    }
  }

  getDocketCases() {
    this.loading = true;
    let dateVal = new Date(this.data.date);
    this.calendarEventsService.getDocketCases(this.orgId, dateVal.getFullYear(), dateVal.getMonth(), dateVal.getDate())
    .subscribe(data => {
      this.loading = false;
      this.hearings = data;
      this.caseIds = _.map(this.hearings, obj => obj.meta.cases);
      if(this.caseIds.length > 0) {
        this.getCaseDetails();
      }
    }, error => {
      this.loading = false;
    });
  }

  getCaseDetails() {
    this.loading = true;
    this.caseService.getCasesInBulk(this.caseIds.join(','))
    .subscribe(data => {
      this.loading = false;
      this.casesList = data;
      if(this.casesList.length > 0) {
        this.tableData.data = this.casesList;
        this.showTable = true;
      }
      else {
        this.showTable = false;
      }
    }, error => {
      this.loading = false;
    });
  }

  openCase(row) {
    this.dialogRef.close(false);
    this.router.navigate(['case', row.summary.organization_id, row.id]);
  }

  downloadAllCaseForms() {
    this.loading = true;
    let dateVal = new Date(this.data.date);
    let month = getMonthName(this.data.date);
    this.presignService.getDocketCaseForms(this.orgId, dateVal.getFullYear(), month, dateVal.getDate(), this.caseIds.join(','))
    .subscribe(data => {
      this.loading = false;
      this.downloadLink = data;
      if(this.downloadLink) {
        this.downloadFile(this.downloadLink);
      }
    }, error => {
      this.loading = false;
    });
  }

  downloadFile(url) {
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.href = url
    a.target = '_blank';
    a.setAttribute('style', 'display: none');
    a.download = 'test';
    a.click();
    document.body.removeChild(a);
  }

  moveCase() {
    this.dialogRef.close();
    const dialogRef = this.dialog.open(CaseActionComponent, {
      // this is data send to the componet
      panelClass: 'AssignGuardian',
      data: {
        type: 'HEARING',
        moveCase: true,
        caseIds: this.casesToBeMoved.join(',')
      }
    });
    dialogRef.afterClosed()
      .subscribe(response => {
        if(response) {
          
        }
    });
  }

  selectedCase(checked, value) {
    if(checked) {
      this.casesToBeMoved.push(value);
    }
    else {
      this.casesToBeMoved = _.remove(this.casesToBeMoved, function(val) {
        return (val != value);
      });
    }
    if(this.casesToBeMoved.length > 0) {
      this.removeBtn = false;
    }
    else {
      this.removeBtn = true;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/main/content/court-dates/docket-case/docket-case.component.ts